import { buildNavigationMenu } from "../../utils/convertUtils";
import { Dashboard } from "mosaic-react-icons";
const navigation = [
    {
        name: "Overview",
        to: "/organizations/:organizationId/:fiscalYear([0-9]{4}|current)?/:period([0-9]*|full)?/overview",
        exact: true,
        icon: Dashboard,
    },
];

export const manageNavigation = (i18n) => {
    return buildNavigationMenu(navigation, i18n);
};
